// extracted by mini-css-extract-plugin
export default {"container_pagination":"Cards_container_pagination__7J6kO","cards":"Cards_cards__YCpqn","not_recipes":"Cards_not_recipes__lTi5G"};